// PAYG withholding coefficient tables, by the date a payment is MADE.
// Source: ATO Schedule 1 (NAT 1004, statement of formulas) and Schedule 8
// (study and training support loans components), each version labelled with
// the date it applies from. A payment dated before the oldest version uses
// the oldest one (earlier schedules weren't available — an approximation;
// annual tax liability is unaffected).
//
// Schedule 1 rows: [weeklyEarningsLessThan, a, b] for y = a·x − b (whole
// dollars), the last row's limit being Infinity. a = b = 0 means nil.

const INF = Infinity;

export const SCHEDULE_1 = [
  {
    from: '2020-10-13',
    scales: {
      1: [
        [88, 0.19, 0.19],
        [371, 0.2348, 3.9639],
        [515, 0.219, -1.9003],
        [932, 0.3477, 64.4297],
        [1957, 0.345, 61.9132],
        [3111, 0.39, 150.0093],
        [INF, 0.47, 398.9324],
      ],
      2: [
        [359, 0, 0],
        [438, 0.19, 68.3462],
        [548, 0.29, 112.1942],
        [721, 0.21, 68.3465],
        [865, 0.219, 74.8369],
        [1282, 0.3477, 186.2119],
        [2307, 0.345, 182.7504],
        [3461, 0.39, 286.5965],
        [INF, 0.47, 563.5196],
      ],
      3: [
        [2307, 0.325, 0.325],
        [3461, 0.37, 103.8462],
        [INF, 0.45, 380.7692],
      ],
      5: [
        [359, 0, 0],
        [721, 0.19, 68.3462],
        [865, 0.199, 74.8365],
        [1282, 0.3277, 186.2115],
        [2307, 0.325, 182.75],
        [3461, 0.37, 286.5962],
        [INF, 0.45, 563.5192],
      ],
      6: [
        [359, 0, 0],
        [721, 0.19, 68.3462],
        [739, 0.199, 74.8365],
        [865, 0.249, 111.8308],
        [924, 0.3777, 223.2058],
        [1282, 0.3377, 186.2119],
        [2307, 0.335, 182.7504],
        [3461, 0.38, 286.5965],
        [INF, 0.46, 563.5196],
      ],
    },
    // Extra withholding an employee may request in a 53-weekly / 27-fortnightly year:
    // [fromEarnings, amount] (whole dollars).
    extra53: [
      [875, 3],
      [2300, 5],
      [3450, 10],
    ],
    extra27: [
      [1750, 13],
      [4550, 21],
      [6750, 40],
    ],
  },
  {
    from: '2024-07-01',
    scales: {
      1: [
        [150, 0.16, 0.16],
        [371, 0.2117, 7.755],
        [515, 0.189, -0.6702],
        [932, 0.3227, 68.2367],
        [2246, 0.32, 65.7202],
        [3303, 0.39, 222.951],
        [INF, 0.47, 487.2587],
      ],
      2: [
        [361, 0, 0],
        [500, 0.16, 57.8462],
        [625, 0.26, 107.8462],
        [721, 0.18, 57.8462],
        [865, 0.189, 64.3365],
        [1282, 0.3227, 180.0385],
        [2596, 0.32, 176.5769],
        [3653, 0.39, 358.3077],
        [INF, 0.47, 650.6154],
      ],
      3: [
        [2596, 0.3, 0.3],
        [3653, 0.37, 181.7308],
        [INF, 0.45, 474.0385],
      ],
      5: [
        [361, 0, 0],
        [721, 0.16, 57.8462],
        [865, 0.169, 64.3365],
        [1282, 0.3027, 180.0385],
        [2596, 0.3, 176.5769],
        [3653, 0.37, 358.3077],
        [INF, 0.45, 650.6154],
      ],
      6: [
        [361, 0, 0],
        [721, 0.16, 57.8462],
        [843, 0.169, 64.3365],
        [865, 0.219, 106.4962],
        [1053, 0.3527, 222.1981],
        [1282, 0.3127, 180.0385],
        [2596, 0.31, 176.5769],
        [3653, 0.38, 358.3077],
        [INF, 0.46, 650.6154],
      ],
    },
    extra53: [
      [875, 3],
      [2575, 6],
      [3650, 12],
    ],
    extra27: [
      [1750, 12],
      [5150, 26],
      [7250, 47],
    ],
  },
  {
    from: '2026-07-01',
    scales: {
      1: [
        [188, 0.15, 0.15],
        [371, 0.2084, 11.0185],
        [515, 0.179, 0.1066],
        [932, 0.3227, 74.1674],
        [2246, 0.32, 71.6508],
        [3303, 0.39, 228.8816],
        [INF, 0.47, 493.1893],
      ],
      2: [
        [362, 0, 0],
        [538, 0.15, 54.3462],
        [673, 0.25, 108.2135],
        [721, 0.17, 54.3473],
        [865, 0.179, 60.8377],
        [1282, 0.3227, 185.1935],
        [2596, 0.32, 181.7319],
        [3653, 0.39, 363.4627],
        [INF, 0.47, 655.7704],
      ],
      3: [
        [2596, 0.3, 0.3],
        [3653, 0.37, 181.7308],
        [INF, 0.45, 474.0385],
      ],
      5: [
        [362, 0, 0],
        [721, 0.15, 54.3462],
        [865, 0.159, 60.8365],
        [1282, 0.3027, 185.1923],
        [2596, 0.3, 181.7308],
        [3653, 0.37, 363.4615],
        [INF, 0.45, 655.7692],
      ],
      6: [
        [362, 0, 0],
        [721, 0.15, 54.3462],
        [865, 0.159, 60.8365],
        [908, 0.3027, 185.1923],
        [1135, 0.3527, 230.6135],
        [1282, 0.3127, 185.1923],
        [2596, 0.31, 181.7308],
        [3653, 0.38, 363.4615],
        [INF, 0.46, 655.7692],
      ],
    },
    extra53: [
      [875, 3],
      [2575, 7],
      [3650, 12],
    ],
    extra27: [
      [1700, 12],
      [5200, 27],
      [7250, 48],
    ],
  },
];

/** Scale 4 (no TFN): a flat rate on earnings, cents ignored. */
export const SCALE_4 = { resident: 0.47, foreign: 0.45 };

/** Tax offsets claimed on the withholding declaration, per-period share. */
export const OFFSET_SHARE = { weekly: 0.019, fortnightly: 0.038, monthly: 0.083, quarterly: 0.25 };

/** Schedule 5: withholding on an additional payment is capped at 47% of it. */
export const ADDITIONAL_PAYMENT_CAP = 0.47;

/**
 * Schedule 8 — the study and training support loan (HELP/STSL) component.
 * Two shapes:
 *  - `banded` (to 23 Sep 2025): y = rate × x, the rate chosen by the band
 *    whose lower bound (`tft` / `noTft`, weekly whole dollars) x reaches;
 *    rates are `BANDED_STSL_RATES`. Below the first bound: nil.
 *  - `marginal` (from 24 Sep 2025): rows [lessThan, a, b], y = a·x − b.
 * `tft` applies when the tax-free threshold is claimed OR the payee is a
 * foreign resident; `noTft` otherwise.
 */
export const BANDED_STSL_RATES = [
  0.01, 0.02, 0.025, 0.03, 0.035, 0.04, 0.045, 0.05, 0.055, 0.06, 0.065, 0.07, 0.075, 0.08, 0.085,
  0.09, 0.095, 0.1,
];

export const SCHEDULE_8 = [
  {
    from: '2020-10-13',
    banded: {
      tft: [
        896, 1035, 1097, 1163, 1232, 1306, 1385, 1468, 1556, 1649, 1748, 1853, 1965, 2082, 2205,
        2340, 2480, 2629,
      ],
      noTft: [
        546, 685, 747, 813, 882, 956, 1035, 1118, 1206, 1299, 1398, 1503, 1615, 1732, 1855, 1990,
        2130, 2279,
      ],
    },
  },
  {
    from: '2021-07-01',
    banded: {
      tft: [
        904, 1043, 1106, 1172, 1243, 1317, 1396, 1480, 1569, 1663, 1763, 1869, 1981, 2100, 2224,
        2360, 2501, 2651,
      ],
      noTft: [
        554, 693, 756, 822, 893, 967, 1046, 1130, 1219, 1313, 1413, 1519, 1631, 1750, 1874, 2010,
        2151, 2301,
      ],
    },
  },
  {
    from: '2022-07-01',
    banded: {
      tft: [
        930, 1073, 1138, 1206, 1278, 1355, 1436, 1523, 1614, 1711, 1814, 1923, 2038, 2160, 2290,
        2427, 2573, 2727,
      ],
      noTft: [
        580, 723, 788, 856, 928, 1005, 1086, 1173, 1264, 1361, 1464, 1573, 1688, 1810, 1940, 2077,
        2223, 2377,
      ],
    },
  },
  {
    from: '2023-07-01',
    banded: {
      tft: [
        991, 1144, 1213, 1286, 1363, 1445, 1531, 1623, 1721, 1824, 1933, 2049, 2172, 2303, 2441,
        2587, 2743, 2907,
      ],
      noTft: [
        641, 794, 863, 936, 1013, 1095, 1181, 1273, 1371, 1474, 1583, 1699, 1822, 1953, 2091, 2237,
        2393, 2557,
      ],
    },
  },
  {
    from: '2024-07-01',
    banded: {
      tft: [
        1046, 1208, 1281, 1358, 1439, 1525, 1617, 1714, 1817, 1926, 2042, 2164, 2294, 2432, 2578,
        2732, 2896, 3070,
      ],
      noTft: [
        696, 858, 931, 1008, 1089, 1175, 1267, 1364, 1467, 1576, 1692, 1814, 1944, 2082, 2228, 2382,
        2546, 2720,
      ],
    },
  },
  {
    from: '2025-07-01',
    banded: {
      tft: [
        1079, 1246, 1321, 1401, 1485, 1574, 1668, 1768, 1874, 1987, 2106, 2233, 2366, 2508, 2659,
        2819, 2988, 3167,
      ],
      noTft: [
        729, 896, 971, 1051, 1135, 1224, 1318, 1418, 1524, 1637, 1756, 1883, 2016, 2158, 2309, 2469,
        2638, 2817,
      ],
    },
  },
  {
    from: '2025-09-24',
    marginal: {
      tft: [
        [1288, 0, 0],
        [2403, 0.15, 193.2692],
        [3447, 0.17, 241.3462],
        [INF, 0.1, 0],
      ],
      noTft: [
        [938, 0, 0],
        [2053, 0.15, 140.7692],
        [2597, 0.17, 181.8462],
        [INF, 0.1, 0],
      ],
    },
  },
  {
    from: '2026-07-01',
    marginal: {
      tft: [
        [1337, 0, 0],
        [2494, 0.15, 200.5615],
        [3577, 0.17, 250.4527],
        [INF, 0.1, 0],
      ],
      noTft: [
        [987, 0, 0],
        [2144, 0.15, 148.0615],
        [2727, 0.17, 190.9527],
        [INF, 0.1, 0],
      ],
    },
  },
];

/** The version of a dated table list in force on `date` ('YYYY-MM-DD'); the oldest if earlier. */
export function versionFor(versions, date) {
  let chosen = versions[0];
  for (const v of versions) if (v.from <= date) chosen = v;
  return chosen;
}
